import { useTranslation } from 'react-i18next'

import { FormInputsType } from '@pages/FormCreateOrEdit/types'

import { GENERATOR_INPUT_TYPE } from '@constants'
import { AutocompleteOption } from '@types'

type Props = {
  isEdit: boolean
  objectsOptions: AutocompleteOption[]
  selectedObjectCommandsOptions: AutocompleteOption[]
  handleChangeCommand: (option: AutocompleteOption) => void
}

export const useInputs = ({
  isEdit,
  objectsOptions,
  selectedObjectCommandsOptions,
  handleChangeCommand,
}: Props) => {
  const { t } = useTranslation()

  const generalInputs: FormInputsType[] = [
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'id',
      label: t('printForms.internalId'),
      placeholder: t('printForms.internalId'),
      rules: { required: true },
      disabled: isEdit,
      gridProps: { xs: 12 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      name: 'title',
      label: t('printForms.titleField'),
      placeholder: t('printForms.titleField'),
      rules: { required: true },
      gridProps: { xs: 12 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.SELECT,
      name: 'paperSize',
      label: t('printForms.paperSize'),
      selectOptions: [
        { id: 0, value: 'A4', name: 'A4' },
        { id: 1, value: 'A5', name: 'A5' },
        { id: 2, value: 'Letter', name: 'Letter' },
      ],
      gridProps: { xs: 12 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.SELECT,
      name: 'orientation',
      label: t('printForms.orientation'),
      selectOptions: [
        { id: 0, value: 'portrait', name: t('printForms.orientations.portrait') },
        { id: 1, value: 'landscape', name: t('printForms.orientations.landscape') },
      ],
      gridProps: { xs: 12 },
    },
  ]

  const commandInputs: FormInputsType[] = [
    {
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      name: 'command.objectCode',
      label: t('printForms.objectCode'),
      placeholder: t('printForms.objectCode'),
      autocompleteOptions: objectsOptions,
      rules: { required: true },
      gridProps: { xs: 12 },
    },
    {
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      name: 'command.commandCode',
      label: t('printForms.commandCode'),
      placeholder: t('printForms.commandCode'),
      autocompleteOptions: selectedObjectCommandsOptions,
      rules: { required: true },
      onChangeAutocomplete: handleChangeCommand,
      gridProps: { xs: 12 },
    },
  ]

  return { generalInputs, commandInputs }
}
